import { connect } from 'react-redux';
import RecentTravelerActivity from './RecentTravelerActivity';
import { fetchRecentActivity } from '../../redux/modules/recentActivity';

const mapStateToProps = ({
  recentActivity,
  system: { isMobile }
}) => ({
  ...recentActivity,
  isMobile
});

const mapDispatchToProps = {
  fetchRecentActivity
};

export default connect(mapStateToProps, mapDispatchToProps)(RecentTravelerActivity);
